import React, { useEffect, useRef, useState } from 'react';

const MAX = 2.6;
const ORANGE = '#F07A1E';
const DARK = '#4A2511';

// Vulpi: segue il mouse/dito, guarda il campo mentre scrivi, si copre gli occhi sulla password.
function usePointerLook(ref, enabled) {
  const [look, setLook] = useState({ x: 0, y: 0 });
  useEffect(() => {
    if (!enabled) return undefined;
    const onMove = (e) => {
      const r = ref.current?.getBoundingClientRect();
      if (!r) return;
      const dx = e.clientX - (r.left + r.width / 2);
      const dy = e.clientY - (r.top + r.height / 2);
      const d = Math.hypot(dx, dy) || 1;
      const k = Math.min(1, d / 180);
      setLook({ x: (dx / d) * MAX * k, y: (dy / d) * MAX * k });
    };
    window.addEventListener('pointermove', onMove, { passive: true });
    return () => window.removeEventListener('pointermove', onMove);
  }, [ref, enabled]);
  return look;
}

export function LoginMascot({ mode = 'idle', lookRatio = 0 }) {
  const ref = useRef(null);
  const hiding = mode === 'hiding';
  const watching = mode === 'watching';
  const pointer = usePointerLook(ref, mode === 'idle');
  const p = watching ? { x: -MAX + 2 * MAX * lookRatio, y: MAX } : pointer;

  return (
    <div className="flex justify-center mb-2 select-none" aria-hidden="true" data-testid="login-mascot" data-mode={mode}>
      <style>{`@keyframes vulpiBlink{0%,92%,100%{transform:scaleY(1)}95%{transform:scaleY(.1)}}
        @keyframes vulpiPaw{from{transform:translateY(14px);opacity:0}to{transform:none;opacity:1}}`}</style>
      <svg ref={ref} width="112" height="94" viewBox="0 0 100 84">
        <path d="M14 38 L20 4 L44 24 Z" fill={ORANGE} />
        <path d="M86 38 L80 4 L56 24 Z" fill={ORANGE} />
        <path d="M18 16 L20 4 L28 11 Z" fill={DARK} />
        <path d="M82 16 L80 4 L72 11 Z" fill={DARK} />
        <path d="M21 30 L23 14 L36 25 Z" fill="#fff" />
        <path d="M79 30 L77 14 L64 25 Z" fill="#fff" />
        <path d="M50 80 C36 80 14 66 9 47 C7 36 16 23 30 21 L70 21 C84 23 93 36 91 47 C86 66 64 80 50 80 Z" fill={ORANGE} />
        <path d="M50 80 C38 80 20 68 15 54 C26 58 38 54 50 62 C62 54 74 58 85 54 C80 68 62 80 50 80 Z" fill="#fff" />

        {!hiding && (
          <g style={{ animation: 'vulpiBlink 4.5s infinite', transformOrigin: '50px 44px' }}>
            <circle cx="35" cy="44" r="7" fill="#fff" />
            <circle cx="65" cy="44" r="7" fill="#fff" />
            <g style={{ transform: `translate(${p.x}px, ${p.y}px)`, transition: 'transform 120ms ease-out' }}>
              <circle cx="35" cy="44" r="3.6" fill="#1a1a1a" />
              <circle cx="65" cy="44" r="3.6" fill="#1a1a1a" />
              <circle cx="36.2" cy="42.8" r="1.1" fill="#fff" />
              <circle cx="66.2" cy="42.8" r="1.1" fill="#fff" />
            </g>
          </g>
        )}
        {!hiding && (
          <g>
            <circle cx="65" cy="44" r="10" fill="none" stroke="#E30613" strokeWidth="2.6" />
            <path d="M72 51 L80 60" stroke="#E30613" strokeWidth="3.4" strokeLinecap="round" />
          </g>
        )}

        <ellipse cx="50" cy="64" rx="3.6" ry="2.6" fill="#1a1a1a" />
        <path
          d={hiding ? 'M45 71 Q50 68 55 71' : 'M45 69 Q47.5 72 50 69 Q52.5 72 55 69'}
          stroke="#1a1a1a" strokeWidth="1.5" fill="none" strokeLinecap="round"
        />

        {hiding && (
          <g style={{ animation: 'vulpiPaw .25s ease-out' }}>
            <path d="M14 84 C16 70 22 58 30 50 L40 56 C34 64 30 74 30 84 Z" fill={ORANGE} />
            <path d="M86 84 C84 70 78 58 70 50 L60 56 C66 64 70 74 70 84 Z" fill={ORANGE} />
            <ellipse cx="35" cy="45" rx="13" ry="10" fill={DARK} transform="rotate(-18 35 45)" />
            <ellipse cx="65" cy="45" rx="13" ry="10" fill={DARK} transform="rotate(18 65 45)" />
            <path d="M29 38 L32 46 M35 36 L36 46 M41 38 L40 46" stroke="#7a4a2a" strokeWidth="1.2" strokeLinecap="round" />
            <path d="M71 38 L68 46 M65 36 L64 46 M59 38 L60 46" stroke="#7a4a2a" strokeWidth="1.2" strokeLinecap="round" />
          </g>
        )}
      </svg>
    </div>
  );
}

export default LoginMascot;
